/*
 * IT之家 - 热榜（服务端路由）
 */
export async function fetchIthomeHot() {
  const res = await fetch('/server-api/ithome')
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  return res.json()
}
